import { CellContext, ColumnDef } from '@shape-ds/components';
import AssetBreadCrumbTooltip from 'components/AssetBreadCrumbTooltip/AssetBreadCrumbTooltip';
import { t } from 'i18next';
import { NotificationSwitch } from '../Form/NotificationSwitch';
import TableButtons from './TableButtons';
import FrequencySelect from '../Form/FrequencySelect';
import { NotificationItem } from 'queries/notifications/contract';

export const notificationColumns = (
  onEdit: (originalData: NotificationItem) => void,
  editingId?: string,
): { [key: string]: Partial<ColumnDef<NotificationItem>> } => {
  return {
    asset: {
      size: 111,
      cell: (cell: CellContext<NotificationItem, unknown>) => (
        <AssetBreadCrumbTooltip assetId={cell.row.original.asset_id} />
      ),
    },
    model_label: { size: 111 },
    frequency: {
      size: 120,
      cell: (cell: CellContext<NotificationItem, unknown>) =>
        cell.row.id === editingId ? (
          <FrequencySelect />
        ) : (
          t(`components:notifications_manager.frequency_options.${cell.row.original.frequency}`)
        ),
    },
    email: {
      size: 65,
      cell: (cell: CellContext<NotificationItem, unknown>) => (
        <NotificationSwitch name="email" disabled={cell.row.id !== editingId} defaultValue />
      ),
    },
    whatsapp: {
      size: 65,
      cell: (cell: CellContext<NotificationItem, unknown>) => (
        <NotificationSwitch
          name="whatsapp"
          disabled={cell.row.id !== editingId}
          defaultValue={false}
        />
      ),
    },
    edit: {
      size: 100,
      enableSorting: false,
      cell: (cell: CellContext<NotificationItem, unknown>) => (
        <TableButtons onEdit={onEdit} notification={cell.row.original} editingId={editingId} />
      ),
    },
  };
};
